import { render, staticRenderFns } from "./crossfilterdc.vue?vue&type=template&id=af5ccb04"
import script from "./crossfilterdc.vue?vue&type=script&lang=js"
export * from "./crossfilterdc.vue?vue&type=script&lang=js"
import style0 from "./crossfilterdc.vue?vue&type=style&index=0&id=af5ccb04&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports